import { Instagram, Facebook, Youtube, Heart } from "lucide-react";
import Logo from "./Logo";
import { scrollToId } from "@/lib/scroll";
import site from "@/data/site.json";

const SOCIAL_ICONS = { instagram: Instagram, facebook: Facebook, youtube: Youtube };

export default function Footer() {
    const year = new Date().getFullYear();
    return (
        <footer data-testid="site-footer" className="bg-forest-deep text-cream">
            <div className="container-x grid gap-12 py-16 md:grid-cols-2 lg:grid-cols-[1.3fr_0.8fr_0.8fr_1.1fr] lg:py-20">
                <div className="flex flex-col gap-5">
                    <Logo light />
                    <p className="max-w-xs text-sm leading-relaxed text-cream/60">
                        Boutique, nutrição e care para cães e gatos que são família. Um projeto demonstrativo de
                        portfólio, criado com muito mimo.
                    </p>
                    <div className="flex gap-3">
                        {site.contact.social.map((s) => {
                            const Icon = SOCIAL_ICONS[s.icon] || Instagram;
                            return (
                                <a
                                    key={s.label}
                                    href={s.href}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    aria-label={`${s.label} (link demonstrativo)`}
                                    title="Link demonstrativo"
                                    data-testid={`footer-social-${s.icon}`}
                                    className="grid h-10 w-10 place-items-center rounded-full border border-cream/15 text-cream/70 transition-all duration-300 hover:-translate-y-1 hover:border-coral hover:text-coral"
                                >
                                    <Icon className="h-4 w-4" />
                                </a>
                            );
                        })}
                    </div>
                </div>

                <nav className="flex flex-col gap-3" aria-label="Links do rodapé">
                    <p className="text-xs font-extrabold uppercase tracking-[0.24em] text-coral">Navegação</p>
                    {site.nav.map((item) => (
                        <a
                            key={item.id}
                            href={`#${item.id}`}
                            data-testid={`footer-link-${item.id}`}
                            onClick={(e) => {
                                e.preventDefault();
                                scrollToId(item.id);
                            }}
                            className="w-fit text-sm text-cream/70 transition-colors hover:text-coral"
                        >
                            {item.label}
                        </a>
                    ))}
                </nav>

                <div className="flex flex-col gap-3">
                    <p className="text-xs font-extrabold uppercase tracking-[0.24em] text-coral">Categorias</p>
                    {site.categories.map((c) => (
                        <a
                            key={c.id}
                            href="#catalogo"
                            data-testid={`footer-category-${c.id}`}
                            onClick={(e) => {
                                e.preventDefault();
                                window.dispatchEvent(new CustomEvent("mimo:set-category", { detail: c.id }));
                                scrollToId("catalogo");
                            }}
                            className="w-fit text-sm text-cream/70 transition-colors hover:text-coral"
                        >
                            {c.label}
                        </a>
                    ))}
                </div>

                <div className="flex flex-col gap-3">
                    <p className="text-xs font-extrabold uppercase tracking-[0.24em] text-coral">Contato</p>
                    <p className="text-sm text-cream/70">{site.contact.whatsappLabel} · demonstrativo</p>
                    <p className="text-sm text-cream/70">{site.contact.emailLabel}</p>
                    <p className="text-sm text-cream/70">{site.contact.addressLabel}</p>
                    {site.contact.hours.map((h) => (
                        <p key={h.days} className="text-xs text-cream/50">
                            {h.days} · {h.time}
                        </p>
                    ))}
                </div>
            </div>

            <div className="border-t border-cream/10">
                <div className="container-x flex flex-col items-center justify-between gap-3 py-6 text-center sm:flex-row sm:text-left">
                    <p className="text-xs text-cream/50">
                        © {year} Mimo &amp; Pata — Pet Shop &amp; Care. Projeto demonstrativo de portfólio; sem fins
                        comerciais.
                    </p>
                    <p className="flex items-center gap-1.5 text-xs text-cream/50">
                        Feito com
                        <Heart className="h-3.5 w-3.5 fill-coral text-coral" aria-hidden="true" />
                        · Imagens licenciadas via Unsplash
                    </p>
                </div>
            </div>
        </footer>
    );
}
